import { createClient } from '@supabase/supabase-js'
import { Constants } from '..';

const supabase = createClient(Constants.BASE_URL, Constants.API_KEY);


export default supabase ;
